import eAnimationType from './eAnimationType';
import * as PIXI from 'pixi.js';
import { Spine } from 'pixi-spine';

class AnimationsLoader {
  constructor() {
    this.animationsData = [
      { type: eAnimationType.EAT_SPINNER, src: 'assets/animations/spinner/spinner.json' },
      { type: eAnimationType.EAT_CELL, src: 'assets/animations/cell/tank_skin_pro.json' },
    ];
  }
  addAssetsToBundle(bundleAssets) {
    for (let asset of this.animationsData) {
      bundleAssets[asset.type] = asset.src;
    }
  }

  createAnimation(type) {
    const resource = PIXI.Assets.get(type);
    return new Spine(resource.spineData);
  }
}

export default new AnimationsLoader();
